import { FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

interface HoursSelectorProps {
  selectedHours: string;
  onHoursChange: (hours: string) => void;
  isMobile?: boolean;
  availableHours: string[];
}

const HoursSelector = ({ selectedHours, onHoursChange, isMobile = false, availableHours }: HoursSelectorProps) => {
  const theme = useTheme();

  const containerSx = isMobile ? { px: 1, mb: 1 } : {};

  const isDisabled = availableHours.length === 0;
  const tooltipTitle = isDisabled ? 'No hourly data available yet' : '';

  return (
    <Box
      sx={{
        ...containerSx,
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
        isolation: 'isolate'
      }}
    >
      <FormControl size="small" sx={{ minWidth: 225 }} disabled={isDisabled}>
        <InputLabel
          id="hours-selector-label"
          sx={{
            fontWeight: 400,
            color: theme.palette.neutral500
          }}
        >
          Show changes starting from:
        </InputLabel>
        <Tooltip title={tooltipTitle} disableHoverListener={!isDisabled} placement="top" arrow>
          <Select
            label="Show changes starting from:"
            value={isDisabled ? '' : selectedHours}
            onChange={(e) => onHoursChange(e.target.value)}
            displayEmpty
            disabled={isDisabled}
            sx={{
              backgroundColor: theme.palette.background.paper,
              height: '40px',
              '& .MuiSelect-select': {
                py: 1
              }
            }}
          >
            {availableHours.map((hour) => (
              <MenuItem key={hour} value={hour}>
                {hour}
              </MenuItem>
            ))}
          </Select>
        </Tooltip>
      </FormControl>
    </Box>
  );
};

export default HoursSelector;
